import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const InfoKBISService = {
  async fetchCompanyInfo(rcs: string) {
    try {
      const response = await axios.get(`${API_URL}/rne/${rcs}`);
      console.log("Response from API:", response.data);
      return response.data.data; 
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async fetchRepresentantAndSiret(rcs: string) {
    try {
      const response = await axios.get(`${API_URL}/rne/representants-siret/${rcs}`);
      console.log("Representant & SIRET:", response.data);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
};
